import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Search, Menu, X, Zap } from "lucide-react";
import { usePro } from "../context/ProContext";

export function Logo({ dark = false }) {
    return (
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link" aria-label="ScorpionPDF — página inicial">
            <img
                src="/logo-scorpionpdf.png"
                alt="Logo ScorpionPDF"
                className="w-10 h-10 flex-shrink-0 object-contain"
                width="40"
                height="40"
            />
            <span className={`font-poster text-3xl tracking-tight ${dark ? "text-white" : "text-black"}`}>
                SCORPIONPDF
            </span>
        </Link>
    );
}

const NAV = [
    { to: "/ferramentas", label: "01. Ferramentas" },
    { to: "/fluxo", label: "02. Fluxo de PDF" },
    { to: "/privacidade", label: "03. 60 Minutos" },
    { to: "/faq", label: "04. Ajuda" },
    { to: "/planos", label: "05. Planos" },
];

export function Header() {
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { isPro, isBusiness } = usePro();

    const submitSearch = (e) => {
        e.preventDefault();
        setOpen(false);
        navigate(query.trim() ? `/ferramentas?q=${encodeURIComponent(query.trim())}` : "/ferramentas");
    };

    return (
        <header className="border-b-2 border-black bg-white sticky top-0 z-40">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 h-18 py-3 flex items-center justify-between gap-4">
                <Logo />
                <nav className="hidden lg:flex items-center gap-6 font-mono-tag text-xs font-bold uppercase tracking-wider text-black" aria-label="Navegação principal">
                    {NAV.map((item) => (
                        <NavLink key={item.to} to={item.to} className="hover:text-[#0284C7] transition-colors" data-testid={`nav-${item.to.slice(1)}`}>
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <form onSubmit={submitSearch} className="hidden md:flex items-center border-2 border-black bg-[#FAFAF9]" role="search">
                        <input
                            type="search"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Buscar ferramenta…"
                            aria-label="Buscar ferramenta"
                            data-testid="header-search-input"
                            className="px-3 py-2 text-xs font-mono-tag bg-transparent w-40 focus:w-52 transition-[width] outline-none"
                        />
                        <button type="submit" aria-label="Pesquisar" data-testid="header-search-button" className="px-3 py-2 bg-black text-[#22D3EE] hover:bg-[#0284C7] hover:text-white transition-colors">
                            <Search className="w-4 h-4" />
                        </button>
                    </form>
                    {isPro ? (
                        <Link
                            to="/historico"
                            data-testid="header-cta"
                            className="hidden sm:inline-flex items-center gap-1.5 px-5 py-2.5 bg-black text-[#22D3EE] font-mono-tag text-xs font-bold uppercase tracking-widest"
                        >
                            <Zap className="w-3.5 h-3.5" aria-hidden="true" /> {isBusiness ? "Business · Histórico" : "Pro · Histórico"}
                        </Link>
                    ) : (
                        <Link
                            to="/ferramentas"
                            data-testid="header-cta"
                            className="hidden sm:inline-block px-5 py-2.5 bg-[#0284C7] hover:bg-black text-white font-mono-tag text-xs font-bold uppercase tracking-widest transition-colors"
                        >
                            Usar Grátis
                        </Link>
                    )}
                    <button
                        className="lg:hidden p-2 border-2 border-black bg-white"
                        onClick={() => setOpen(!open)}
                        aria-label={open ? "Fechar menu" : "Abrir menu"}
                        aria-expanded={open}
                        data-testid="mobile-menu-button"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="lg:hidden border-t-2 border-black bg-white px-6 py-4 space-y-3" data-testid="mobile-menu">
                    {NAV.map((item) => (
                        <NavLink key={item.to} to={item.to} onClick={() => setOpen(false)} className="block font-mono-tag text-sm font-bold uppercase tracking-wider text-black py-2">
                            {item.label}
                        </NavLink>
                    ))}
                    <form onSubmit={submitSearch} className="flex items-center border-2 border-black" role="search">
                        <input
                            type="search"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Buscar ferramenta…"
                            aria-label="Buscar ferramenta"
                            data-testid="mobile-search-input"
                            className="flex-1 px-3 py-3 text-sm font-mono-tag outline-none"
                        />
                        <button type="submit" aria-label="Pesquisar" data-testid="mobile-search-button" className="px-4 py-3 bg-black text-[#22D3EE]">
                            <Search className="w-4 h-4" />
                        </button>
                    </form>
                </div>
            )}
        </header>
    );
}
